"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var Transition_1 = require("../Transition/Transition");
var Tooltip_styles_1 = __importDefault(require("./Tooltip.styles"));
function Tooltip(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, label = _a.label, children = _a.children, opened = _a.opened, _b = _a.delay, delay = _b === void 0 ? 0 : _b, _c = _a.gutter, gutter = _c === void 0 ? 5 : _c, _d = _a.color, color = _d === void 0 ? 'gray' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.withArrow, withArrow = _f === void 0 ? false : _f, _g = _a.arrowSize, arrowSize = _g === void 0 ? 3 : _g, _h = _a.position, position = _h === void 0 ? 'top' : _h, _j = _a.placement, placement = _j === void 0 ? 'center' : _j, _k = _a.transition, transition = _k === void 0 ? 'slide-up' : _k, _l = _a.transitionDuration, transitionDuration = _l === void 0 ? 100 : _l, _m = _a.zIndex, zIndex = _m === void 0 ? 1000 : _m, transitionTimingFunction = _a.transitionTimingFunction, _o = _a.width, width = _o === void 0 ? 'auto' : _o, _p = _a.wrapLines, wrapLines = _p === void 0 ? false : _p, _q = _a.allowPointerEvents, allowPointerEvents = _q === void 0 ? false : _q, elementRef = _a.elementRef, tooltipRef = _a.tooltipRef, tooltipId = _a.tooltipId, others = __rest(_a, ["className", "themeOverride", "label", "children", "opened", "delay", "gutter", "color", "disabled", "withArrow", "arrowSize", "position", "placement", "transition", "transitionDuration", "zIndex", "transitionTimingFunction", "width", "wrapLines", "allowPointerEvents", "elementRef", "tooltipRef", "tooltipId"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = Tooltip_styles_1.default({ theme: theme, color: color, gutter: gutter, arrowSize: arrowSize });
    var timeoutRef = react_1.useRef();
    var _r = react_1.useState(false), _opened = _r[0], setOpened = _r[1];
    var visible = (typeof opened === 'boolean' ? opened : _opened) && !disabled;
    var duration = hooks_1.useReducedMotion() ? 0 : transitionDuration;
    var handleOpen = function () {
        window.clearTimeout(timeoutRef.current);
        setOpened(true);
    };
    var handleClose = function () {
        if (delay !== 0) {
            timeoutRef.current = window.setTimeout(function () {
                setOpened(false);
            }, delay);
        }
        else {
            setOpened(false);
        }
    };
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.wrapper, className), ref: tooltipRef }, others),
        react_1.default.createElement(Transition_1.Transition, { mounted: visible, transition: transition, duration: duration, timingFunction: transitionTimingFunction }, function (transitionStyles) {
            var _a;
            return (react_1.default.createElement("div", { id: tooltipId, role: "tooltip", style: { zIndex: zIndex, width: width, pointerEvents: allowPointerEvents ? 'all' : 'none' }, "data-mantine-tooltip": true, className: clsx_1.default(classes.tooltip, classes[placement], classes[position]), ref: tooltipRef },
                react_1.default.createElement("div", { "data-mantine-tooltip-inner": true, className: clsx_1.default(classes.tooltipInner, (_a = {},
                        _a[classes.withArrow] = withArrow,
                        _a)), style: __assign(__assign({}, transitionStyles), { whiteSpace: wrapLines ? 'normal' : 'nowrap' }) }, label)));
        }),
        react_1.default.createElement("div", { onMouseEnter: handleOpen, onMouseLeave: handleClose }, children)));
}
exports.Tooltip = Tooltip;
Tooltip.displayName = '@mantine/core/Tooltip';
